<div class="report-export">
  <div mat-dialog-content>
    <mat-form-field>
      <textarea matInput cdkTextareaAutosize readonly [value]="data|json"></textarea>
    </mat-form-field>
  </div>
</div>